import React from "react";
import { useSelector } from "react-redux";
import { Button, Popover } from "@bca/ui-library";
import css from "@styled-system/css";

import PopoverContent from "./PopoverContent";
import PrintSVG from "./PrintSVG";
import { PrintProps } from "./PrintProps.type";
import { StoreType } from "../StoreType";
import { GET_STATE } from "../redux/slices/appSlice";

const PopoverDesktop: React.FunctionComponent<PrintProps> = ({
  printUrls,
  vehicleAnalytics,
  pdfEnabled,
}) => {
  const {
    app: { isPrintServiceUnavailable },
  }: StoreType = useSelector(GET_STATE);

  const button = (
    <Button
      variant="tertiary"
      padding="10px"
      height="auto"
      css={`
        &:hover,
        &[aria-expanded="true"] {
          ${css({
            path: {
              fill: "primary-light-blue",
            },
          })}
        }
      `}
    >
      <PrintSVG width="21px" height="21px" fill="footer-blue" />
    </Button>
  );

  return (
    <>
      {isPrintServiceUnavailable ? (
        button
      ) : (
        <Popover
          width="260px"
          placement="bottom left"
          offsetY={1}
          offsetX="-106px"
        >
          {button}
          <PopoverContent
            printUrls={printUrls}
            vehicleAnalytics={vehicleAnalytics}
            pdfEnabled={pdfEnabled}
          />
        </Popover>
      )}
    </>
  );
};

export default PopoverDesktop;
